import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from './ui/avatar';
import { cn } from '../lib/utils';

const SIZE_MAP = {
  xs: 'w-5 h-5 text-[10px]',
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-sm',
  lg: 'w-9 h-9 text-sm',
  xl: 'w-10 h-10 text-base',
};

export function UserAvatar({ name, avatarUrl, size = 'md', className, colorClass }) {
  const initial = name?.charAt(0)?.toUpperCase() || '?';
  const fallbackColor = colorClass || 'bg-gradient-to-br from-blue-500 to-purple-500';

  return (
    <Avatar className={cn(SIZE_MAP[size], 'shrink-0', className)}>
      {avatarUrl && <AvatarImage src={avatarUrl} alt={name} />}
      <AvatarFallback className={cn('text-foreground font-medium', fallbackColor)}>
        {initial}
      </AvatarFallback>
    </Avatar>
  );
}

export default UserAvatar;
